import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import React from 'react';
// import { SelectChangeEvent } from '@mui/material/Select';
import { useToggle } from 'usehooks-ts';

import { CarouselDeckVisualization } from './CarouselDeckVisualization';
import { GridDeckVisualization } from './GridDeckVisualization';
import { LabwareLoadingTable } from './LabwareLoadingTable';
// import { LoadUnloadOrderSelect } from './LoadUnloadOrderSelect';
import type {
  DeckLayoutData,
  // DeckLayoutType,
  LabwareDataForTask,
  LoadOrderCarouselLayout,
  LoadOrderGridLayout,
} from '../../types';

type LoadOrderUnion = LoadOrderGridLayout | LoadOrderCarouselLayout;

export type HandleChangeSlotFn = (labwareId: string, slot: number) => void;

export type LabwareSlotData = Array<{ slot: number; data: LabwareDataForTask }>;

// TODO(IL, 2024-04-01): this one-off casting in the component isn't very nice...
/*
function makeOnChangeLoadOrder(
  deckLayoutType: DeckLayoutType,
  cb: (loadOrder: LoadOrderUnion) => void
): (value: string) => void {
  return (value: string) => {
    if (deckLayoutType === 'grid') {
      if (
        value === 'firstToLast' ||
        value === 'lastToFirst' ||
        value === 'custom' ||
        value === 'any'
      ) {
        const v: LoadOrderGridLayout = value;
        cb(v);
        return;
      }
    } else if (deckLayoutType === 'carousel') {
      if (
        value === 'clockwise' ||
        value === 'counterclockwise' ||
        value === 'custom' ||
        value === 'any'
      ) {
        const v: LoadOrderCarouselLayout = value;
        cb(v);
        return;
      }
    } else {
      deckLayoutType satisfies never;
    }
    // eslint-disable-next-line no-console
    console.error(
      `unexpected grid loadOrder value ${value} for deck layout type ${deckLayoutType}`
    );
  };
}
*/

export interface Props {
  handleChangeSlot: HandleChangeSlotFn;
  handleChangeLoadOrder: (loadOrder: LoadOrderUnion) => void;
  handleChangeUnloadOrder: (loadOrder: LoadOrderUnion) => void;
  loadOrder: LoadOrderUnion;
  unloadOrder: LoadOrderUnion;
  deckLayoutData: DeckLayoutData;
  labwareSlotData: LabwareSlotData;
}

export function DeckLayout(props: Props): JSX.Element {
  const {
    handleChangeSlot,
    // handleChangeLoadOrder,
    // handleChangeUnloadOrder,
    // loadOrder,
    // unloadOrder,
    deckLayoutData,
    labwareSlotData,
  } = props;

  // const { deckLayoutType } = deckLayoutData;

  const [deckIsCollapsed, toggleDeckIsCollapsed, _] = useToggle(false);

  // ================================================================
  // NOTE(IL, 2024-04-05): Load/Unload order hidden for user test 1
  // ================================================================

  // const onChangeLoadOrder = useCallback(
  //   (e: SelectChangeEvent) => {
  //     makeOnChangeLoadOrder(
  //       deckLayoutType,
  //       handleChangeLoadOrder
  //     )(e.target.value);
  //   },
  //   [deckLayoutType, handleChangeLoadOrder]
  // );

  // const onChangeUnloadOrder = useCallback(
  //   (e: SelectChangeEvent) => {
  //     makeOnChangeLoadOrder(
  //       deckLayoutType,
  //       handleChangeUnloadOrder
  //     )(e.target.value);
  //   },
  //   [deckLayoutType, handleChangeUnloadOrder]
  // );

  const deckVizSx = { margin: '0 4rem' };
  let deckVisualization: JSX.Element | null = null;
  if (deckLayoutData.deckLayoutType === 'carousel') {
    deckVisualization = (
      <CarouselDeckVisualization
        sx={deckVizSx}
        slots={deckLayoutData.slots}
        labwareSlotData={labwareSlotData}
      />
    );
  } else if (deckLayoutData.deckLayoutType === 'grid') {
    deckVisualization = (
      <GridDeckVisualization
        sx={deckVizSx}
        rows={deckLayoutData.rows}
        columns={deckLayoutData.columns}
        labwareSlotData={labwareSlotData}
      />
    );
  } else {
    deckLayoutData satisfies never;
  }

  return (
    <Stack maxWidth="30rem" gap="0.5rem">
      <Stack direction="row">
        <Typography variant="body1">Layout</Typography>
        {deckIsCollapsed ? (
          <ExpandMoreIcon onClick={toggleDeckIsCollapsed} />
        ) : (
          <ExpandLessIcon onClick={toggleDeckIsCollapsed} />
        )}
      </Stack>

      {deckIsCollapsed ? null : (
        <>
          {deckVisualization}
          <LabwareLoadingTable
            labwareSlotData={labwareSlotData}
            handleChangeSlot={handleChangeSlot}
          />
        </>
      )}

      {/* <LoadUnloadOrderSelect
        deckLayoutType={deckLayoutData.deckLayoutType}
        loadOrUnload="load"
        value={loadOrder}
        onChange={onChangeLoadOrder}
      />
      <LoadUnloadOrderSelect
        deckLayoutType={deckLayoutData.deckLayoutType}
        loadOrUnload="unload"
        value={unloadOrder}
        onChange={onChangeUnloadOrder}
      /> */}
    </Stack>
  );
}
